import { FeatureFlagName } from '@api'
import { useUnit } from 'effector-react'

import MenuIcon from '@/assets/icons/icon-menu.svg'
import { $availableFeatures } from '@/models/feature-flags.ts'
import { isFeatureAvailable as isFeatureAvailableUtil } from '@/utils/featureFlags.ts'

import { IconButton } from '../components/icon-button'
import { Introduction } from './Introduction.tsx'
import { BrowserZoom } from './browser-zoom/BrowserZoom.tsx'
import { CreatorHeroSettingsPopup } from './creator-hero-settings-popup.tsx'
import { Notifications } from './notifications'
import { PpvOverview } from './ppv-overview/PpvOverview.tsx'
import { Tabs } from './tabs'

interface Props {
  toggleMobileSidebar: () => void
}

export const ChattingHeader = ({ toggleMobileSidebar }: Props) => {
  const availableFeatures = useUnit($availableFeatures)
  const isUserFlowFeatureAvailable = isFeatureAvailableUtil(
    availableFeatures,
    FeatureFlagName.USER_FLOW,
  )

  return (
    <div className="relative flex h-[55px] max-w-full items-center overflow-hidden border-b bg-card p-2">
      <IconButton
        icon={MenuIcon}
        onClick={toggleMobileSidebar}
        className="mx-2 hidden text-title max-lg:block"
      />
      <Tabs />
      <div className="ml-auto flex items-center gap-3">
        <BrowserZoom />
        {!isUserFlowFeatureAvailable && <Introduction />}
        <PpvOverview />
        <Notifications />
        <CreatorHeroSettingsPopup />
      </div>
    </div>
  )
}
